module.exports = __webpack_public_path__ + "img/045-andorra.24daf954.svg";